<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12"
        ><div class="text-h5 font-weight-black my-2">
          {{ componentData.title }}
        </div>
      </v-col>
      <v-col cols="12" class="pb-5">
        <div class="text-body-1" align="left">
          {{ componentData.description }}
        </div>
      </v-col>
      <v-col>
        <v-form
          ref="form"
          v-model="componentData.formSetting.valid"
          lazy-validation
        >
          <v-text-field
            outlined
            hide-details="auto"
            v-model="resetPwdDate.email"
            :label="componentData.formSetting.input1.label"
            :placeholder="componentData.formSetting.input1.placeholder"
            :rules="componentData.formSetting.input1.rules"
            :error-messages="componentData.formSetting.input1.errorMsg"
            @focus="ResetErrorValidation"
          ></v-text-field>
        </v-form>
        <div class="py-4"></div>
        <v-btn
          block
          large
          color="primary"
          :loading="componentData.loading"
          @click="SendEmail()"
        >
          <span class="mx-2 text-capitalize">{{
            componentData.sendResetUrl
          }}</span>
        </v-btn>
        <div class="py-4"></div>

        <v-alert
          :value="componentData.sendAlert"
          dense
          text
          type="success"
          icon="mdi-check-circle-outline"
          transition="slide-y-transition"
          align="left"
        >
          {{ componentData.sendSuccess }}
        </v-alert>

        <div>
          <v-btn
            text
            color="deep-purple accent-3"
            class="pa-0 pb-1"
            plain
            @click="GoSignIn()"
          >
            {{ componentData.backSignin }}
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Mail_SendResetPwdMail } from "@/apis/api";

export default {
  name: "ResetPwd",
  data() {
    return {
      componentData: {
        title: "重設密碼",
        description:
          "請輸入您註冊小芋頭帳號的電子信箱，我們會發送重設密碼的連結。",
        formSetting: {
          valid: true,
          input1: {
            label: "電子信箱",
            placeholder: "email",
            rules: [
              (v) => !!v || "此欄位必填",
              (v) =>
                /^\w+((-\w+)|(\.\w+)|(\+\w+))*@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/.test(
                  v
                ) || "格式錯誤，請重新輸入",
            ],
            errorMsg: "",
          },
        },
        sendResetUrl: "發送重設連結",
        backSignin: "返回登入",
        sendSuccess: "發送成功",
        sendAlert: false,
        loading: false,
      },
      resetPwdDate: {
        email: "",
      },
    };
  },
  methods: {
    // 顯示密碼切換
    EyeSwitch() {
      this.pwdVisiable = !this.pwdVisiable;
    },
    // 清除表單驗證
    ResetErrorValidation() {
      // this.$refs.form.resetValidation();
      this.componentData.formSetting.input1.errorMsg = "";
    },
    // 發送重設連結
    SendEmail() {
      // 重置alert
      this.componentData.sendAlert = false;
      // 驗證不過直接回傳
      this.$refs.form.validate();
      if (!this.$refs.form.validate()) return false;

      this.componentData.loading = true;
      // api
      Mail_SendResetPwdMail(this.resetPwdDate.email)
        .then((res) => {
          console.log(res.data.message);
          this.componentData.loading = false;
          // 成功跳alert
          this.componentData.sendAlert = true;
        })
        .catch((err) => {
          this.componentData.loading = false;
          this.componentData.formSetting.input1.errorMsg =
            err.response.data.message;
        });
    },
    GoSignIn() {
      this.$emit("switch", "SignIn");
    },
  },
};
</script>
